import {
  getTaskInfos,
  getUnpaginatedTaskInfo,
} from '@dispatch/shared/services';
import { TasksListFilter } from '@dispatch/shared/types';
import { GridSortItem } from '@mui/x-data-grid';
import { usePaginatedQuery } from '../api/usePaginatedQuery';
import { useQuery } from '../useQuery';
import { useCurrentUserAsResourceId, useCurrentUserResource } from '../users';

export const useGetTaskInfos = (
  filters: TasksListFilter,
  sorting?: GridSortItem | null,
  enabled = true
) => {
  const { isAdjuster } = useCurrentUserResource();
  const currentUser = useCurrentUserAsResourceId();

  //not the best way of doing this but could not find an alternative
  if (isAdjuster) {
    filters.assignedResourceIds = [String(currentUser.value)];
    filters.locked = true;
  }

  if (filters?.hideCancelledTasks) {
    filters.queueName = [
      'auto_dispatch_q',
      'manual_dispatch_q',
      'dispatched_q',
      'needs_attention_q',
      'wip_q',
      'egress',
    ];
  }

  return usePaginatedQuery(
    ['infos', filters, sorting],
    (token) => getTaskInfos(filters, token, sorting),
    {
      enabled,
    }
  );
};

export const useGetIncompletedTasks = (filters: TasksListFilter) => {
  const queueNames = ['dispatched_q', 'wip_q'];

  return useQuery(['incompleteTasks', filters], () => {
    const incompleteFilters = {
      ...filters,
      queueName: queueNames,
    };
    return getUnpaginatedTaskInfo(incompleteFilters);
  });
};

export const useGetAllTasksForResource = (resourceId: string) => {
  const filters: TasksListFilter = {
    pageSize: 10, // this is needed but is not used
    assignedResourceIds: [resourceId],
  };

  return useQuery(['all_tasks', filters], () =>
    getUnpaginatedTaskInfo(filters)
  );
};
